/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetUsersAPIKeysStatus200,
  GetUsersAPIKeysStatus400,
  GetUsersAPIKeysStatus500,
} from '../types/GetUsersAPIKeys'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUsersAPIKeys } from '../clients/getUsersAPIKeys'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersAPIKeysQueryKey = () => [{ url: '/v1/user/apikey' }] as const

type GetUsersAPIKeysQueryKey = ReturnType<typeof getUsersAPIKeysQueryKey>

export function getUsersAPIKeysQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getUsersAPIKeysQueryKey()
  return queryOptions<
    GetUsersAPIKeysStatus200,
    ResponseErrorConfig<GetUsersAPIKeysStatus400 | GetUsersAPIKeysStatus500>,
    GetUsersAPIKeysStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUsersAPIKeys({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get user's api keys
 * {@link /v1/user/apikey}
 */
export function useGetUsersAPIKeys<
  TData = GetUsersAPIKeysStatus200,
  TQueryData = GetUsersAPIKeysStatus200,
  TQueryKey extends QueryKey = GetUsersAPIKeysQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUsersAPIKeysStatus200,
        ResponseErrorConfig<GetUsersAPIKeysStatus400 | GetUsersAPIKeysStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersAPIKeysQueryKey()

  const queryResult = useQuery(
    {
      ...getUsersAPIKeysQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetUsersAPIKeysStatus400 | GetUsersAPIKeysStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
